$(document).ready(function () {
	
	window.previousLocation = null;

    function showMoreWindow($targetWindow) {
        $targetWindow.scrollTop(0);
        $('.more-window').removeClass('shown');
        $targetWindow.addClass('shown');
        $targetWindow.focus();
        LS.trapFocus($targetWindow.selector, false);
        $('body').addClass('more-window-open');
    }
    function hideMoreWindow() {
        $('.more-window').removeClass('shown');
        $('body').removeClass('more-window-open');
        if (window.previousLocation) {
            $('window').scrollTop(window.previousLocation);
        }
		LS.returnFocus();
    }

    $('.more-window-trigger').on('click', function (e) {
        e.preventDefault();
        var $targetWindow = $($(this).data('target'));
        window.returnFocusTo = $(this);
        window.previousLocation = $(this).scrollTop();
        showMoreWindow($targetWindow);
    });

    $('.more-window .panel-close').on('click', function (e) {
        e.preventDefault();
        hideMoreWindow()
    });

    $('body').on('keyup', function (e) {
        if (LS.isEscape(e)) {
            hideMoreWindow()
        }
    });

    if (location.hash) {
        var $el = $(location.hash);
        if ($el.length && $el.hasClass('more-window')) {
            showMoreWindow($el);
        }
    }
});
